import React from 'react';
import { Stack } from '@guestyci/arc';
import { useBreakpoint } from '../../utils/useBreakpoint';
import guestyLogo from '../../assets/guesty-logo-dark-blue.svg';
import HelpButton from '../components/HelpButton';
import LanguageSelect from '../components/LanguageSelect';

const LoginPageHeader = ({ isWelcomeStep, onLanguageChange, children }) => {
  const isDesktop = useBreakpoint('md');
  const isActivationFlow = window.sessionStorage.getItem('isActivationFlow');

  return (
    <Stack
      direction="row"
      align="center"
      className="gst-h-16 gst-w-full gst-px-5 lg:gst-px-16 gst-bg-white gst-sticky gst-top-0 gst-z-10"
    >
      <img src={guestyLogo} alt="Guesty" />
      {isActivationFlow && (
        <Stack direction="row" align="center" spacing={2}
          className={`gst-ml-auto gst-w-auto${isDesktop ? ' gst-pr-16' : ''}`}
        >
          <HelpButton />
          {isWelcomeStep && (
            <LanguageSelect onLanguageChange={onLanguageChange} />
          )}
        </Stack>
      )}
      {children}
    </Stack>
  );
};

export default LoginPageHeader;
